import { render, staticRenderFns } from "./passwordreset.vue?vue&type=template&id=95e3da6e"
import script from "./passwordreset.vue?vue&type=script&lang=js"
export * from "./passwordreset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports